import { debounce, getWindowWidth } from "../functions.js";
import StdAnimations from "../StdAnimations.js";

export default function MainHeroModule(element) {

    let imagesInterval;
    let $currentImage;
    let tl;
    let qs = element.querySelector.bind(element);
    let qsa = element.querySelectorAll.bind(element);
    let $box = qs('.mainhero__box');

    function getRandomImage(type, notThis) {
        while (true) {
            let imageContainers = qsa('*[data-type=' + type + ']');

            let imageContainer = imageContainers[Math.floor(Math.random() * imageContainers.length)];

            if (notThis && imageContainer === notThis) {
                continue;
            }

            return imageContainer;
        }
    }

    function cycleImages(type, speed = 500) {

        stopCycling();

        let intervalFn = function() {
            if ($currentImage) {
                css($currentImage, { opacity: 0, zIndex: 2 })
            }
            $currentImage = getRandomImage(type, $currentImage);
            css($currentImage, { opacity: 1, zIndex: 1 })
        }

        imagesInterval = setInterval(intervalFn, speed);
        intervalFn();
    }

    function css($elm, props) {
        for (let prop in props) {
            $elm.style[prop] = props[prop];
        }
    }

    function hideCurrentImage() {
        css($currentImage, { opacity: 0 })
    }

    function stopCycling () {
        clearInterval(imagesInterval);
    }

    function createTimeline() {
        tl = gsap.timeline({ 
            defaults: { clearProps: 'all' },
            onStart: function() {
                cycleImages('mobile', 2000);
            },
            onComplete: function() {
                // stopCycling();
                // let speed = window.isLH ? 50000 : 5000;
                // cycleImages('mobile', speed);
            }
        });

        // tl.to($box, { opacity: 1, duration: 0});

        // tl.from($box, { 
        //     width: '85vw', 
        //     aspectRatio: 1.5,
        //     duration: 5, 
        //     onStart: function() {
        //         cycleImages('desktop');
        //     },
        //     onComplete: function() {
        //         stopCycling();
        //         hideCurrentImage();
        //         let speed = window.isLH ? 50000 : 5000;
        //         cycleImages('mobile', speed);
        //     }
        // });

        // tl.from($box, { 
        //     aspectRatio: '+=0.4', 
        //     duration: 2, 
        //     onComplete: function() {
        //         stopCycling();
        //         let speed = window.isLH ? 50000 : 2000;
        //         cycleImages('mobile', speed);
        //     }
        // });

        tl.from(qs('.mainhero__shade'),   {opacity: 0, duration: 1});

        tl.from(qs('.mainhero__line--1'), 	    { rotateX: '-30deg', scale: 0.8, opacity: 0, duration: 2, ease: 'back', x: 100 }, '<');
        tl.from(qs('.mainhero__line--2'), 	    StdAnimations.merge('appearingTitle'), '<0.5');
        tl.from(qs('.mainhero__line--3'), 	    StdAnimations.merge('appearingTitle'), '<0.5');
        tl.from(qs('.mainhero__line--4'), 	    StdAnimations.merge('appearingTitle'), '<0.5');

        tl.from(qs('.mainhero__accesory--1'),   {scale: 2, opacity: 0, duration: 1, ease: 'back.out(1.2)'});
        tl.from(qs('.mainhero__accesory--2'),   {scale: 2, opacity: 0, duration: 1, ease: 'back.out(1.2)', delay: 0.5}, '<');
       
        tl.pause();

        // window.tl = tl;

        // window.addEventListener('resize', debounce(() => {
        //     if (!tl.isActive()) { 
        //         tl.clear();
        //         return;
        //     }
        //     if (tl.progress() >= 0.95) {
        //         tl.invalidate().progress(0.95).play();
        //     } else {
        //         tl.invalidate().pause(0).play();
        //     }
        // }, 100, false));

    }

    function init() {
        createTimeline();
        if (window.isLH) {
            tl.progress(1).play();
        } else {
            tl.play();
        }
    }

    init();

}
